import React from 'react';
import styled from 'styled-components';
import { Search } from '../../../../assets/svgs';

function KeywordSearch({ handleSearchInput, searchQuery, placeholder, autoFocus = false }) {
  return (
    <Wrapper>
      <KeywordInput
        type="text"
        name="search"
        autoComplete="off"
        placeholder={placeholder}
        onChange={handleSearchInput}
        value={searchQuery}
        autoFocus={autoFocus}
      />
      <Search />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  svg {
    height: 1.325rem;
    left: 0.45rem;
    position: absolute;
    top: 0.5rem;
    width: 1.325rem;

    @media (width >= 768px) {
      left: 0;
    }
  }
`;

const KeywordInput = styled.input`
  border-style: none;
  border-bottom: 0.063em solid var(--genseq-purple);
  color: var(--genseq-blue);
  font-size: 1rem;
  font-weight: 300;
  height: 2.063em;
  margin-bottom: 1.313em;
  max-width: 100%;
  outline: none;
  padding-left: 2.25em;

  @media (width >= 768px) {
    padding-left: 1.625em;
  }

  &::placeholder {
    color: var(--genseq-blue);
    font-size: 1rem;
    font-style: italic;
    font-weight: 300;
    padding-bottom: -0.313em;
  }
`;

export default KeywordSearch;